/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ErrorLogDto from './ErrorLogDto';

/**
 * The PaginatedErrorLogsDto model module.
 * @module model/PaginatedErrorLogsDto
 * @version v0
 */
class PaginatedErrorLogsDto {
    /**
     * Constructs a new <code>PaginatedErrorLogsDto</code>.
     * @alias module:model/PaginatedErrorLogsDto
     */
    constructor() { 
        
        PaginatedErrorLogsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedErrorLogsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedErrorLogsDto} obj Optional instance to populate.
     * @return {module:model/PaginatedErrorLogsDto} The populated <code>PaginatedErrorLogsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedErrorLogsDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('errorLogs')) {
                obj['errorLogs'] = ApiClient.convertToType(data['errorLogs'], [ErrorLogDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedErrorLogsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedErrorLogsDto</code>.
     */
    static validateJSON(data) {
        if (data['errorLogs']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['errorLogs'])) {
                throw new Error("Expected the field `errorLogs` to be an array in the JSON data but got " + data['errorLogs']);
            }
            // validate the optional field `errorLogs` (array)
            for (const item of data['errorLogs']) {
                ErrorLogDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedErrorLogsDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedErrorLogsDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedErrorLogsDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedErrorLogsDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/ErrorLogDto>} errorLogs
 */
PaginatedErrorLogsDto.prototype['errorLogs'] = undefined;






export default PaginatedErrorLogsDto;

